module.exports = __webpack_public_path__ + "media/11_21.4fdc1b26.wav";